import useActivePosition from 'hooks/models/position/useActivePosition';

export default function useCanViewExpenses() {
  const position = useActivePosition();
  return position.viewProjectExpenses && position.viewMemberExpenses;
}
